import PUserTransaction from "./Default/PUserTransaction";

export default PUserTransaction;
